<template>
  <v-container @click.stop="$store.commit('product/CLOSE_DIALOG', closeDialog)">
    <v-row>
      <v-col class="d-flex">
        <div
          v-if="
            department &&
            department.category_id &&
            department.category_id !== 'More'
          "
          class="d-flex flex-wrap flex-sm-nowrap"
        >
          <div class="align-center d-flex">
            <div class="mr-1 side-nav-image-size">
              <Icon
                :name="
                  removeCommasAndSpaces(
                    getDepartmentDisplayName(department.category_id),
                  ).toLowerCase()
                "
                :color="$vuetify.theme.themes.light.primary"
                :title="getDepartmentDisplayName(department.category_id)"
                class="full-width"
              ></Icon>
            </div>
            <router-link
              class="d-flex justify-end"
              :to="departmentRoute(department.category_id)"
              >{{
                getDepartmentDisplayName(department.category_id)
              }}</router-link
            >
            <v-icon color="primary">mdi-chevron-right</v-icon>
          </div>
        </div>
        <div v-else class="d-flex flex-wrap flex-sm-nowrap">
          <div class="mr-1 side-nav-image-size">
            <Icon
              :name="
                removeCommasAndSpaces(
                  department?.category_name || category.category_name,
                ).toLowerCase()
              "
              :color="$vuetify.theme.themes.light.primary"
              :title="department?.category_name || category.category_name"
              class="full-width"
            ></Icon>
          </div>
          <router-link
            class="d-flex justify-end"
            :to="routeDepartmentWithoutCategories()"
            >{{ category.category_name }}</router-link
          >
        </div>
        <div
          v-if="
            department &&
            department.category_id &&
            department.category_id !== 'More'
          "
          class="d-flex flex-wrap flex-sm-nowrap"
        >
          <router-link
            class="d-flex justify-end"
            :to="categoryRoute(department, category)"
            >{{ category.category_name }}</router-link
          >
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import { slug } from "github-slugger";
import Icon from "@/components/UI/Icon.vue";
import { removeCommasAndSpaces } from "@/util.js";

export default {
  name: "ProductTitle",
  components: { Icon },
  methods: {
    categoryRoute(department, category) {
      const categoryRoute = {
        name: "category",
        params: {
          departmentId: department
            ? department.category_id
            : category.category_id,
          categoryName: category.category_name,
          categoryId: category.category_id,
        },
      };
      return department?.category_id === "Menu"
        ? this.routeToMenu(category.category_name)
        : categoryRoute;
    },
    departmentRoute(departmentId) {
      const departmentRoute = { name: "department", params: { departmentId } };
      return departmentId === "Menu" ? this.routeToMenu() : departmentRoute;
    },
    removeCommasAndSpaces,
    routeDepartmentWithoutCategories() {
      let category =
        this.category.category_name === "More"
          ? this.category.category_name
          : this.category.category_id;
      return `/department/${category}/category/${category}`;
    },
    routeToMenu(categoryName) {
      return {
        name: "menu",
        ...(categoryName && {
          hash: `#${slug(categoryName.replace(/^\d/, "abc$&"))}`,
        }),
      };
    },
  },
  computed: {
    ...mapGetters("departments", {
      getDepartmentDisplayName: "getDepartmentDisplayName",
    }),
  },
  props: {
    category: Object,
    closeDialog: String,
    department: Object,
  },
};
</script>
